<template>
  <div class="how-active">
    <div class="ha-des">
      <p class="black">问：我录音失败或无法提交作业</p>
      <p>答：一般情况下是由于您的网络问题导致的，建议您从WiFi更换到4G网络，或从4G网络切换到WiFi后再试。如果问题仍然出现，请您在问题出现时，马上在手机上截个图，可瀚学堂APP会自动出现反馈问题的窗口，您点击“反馈问题”，将图片上传后，联系我们，告知截图时间，我们会通过后台为您排查问题。</p>
    </div>
    <div class="ha-img">
      <img src="./img/problem1.png" alt="">
    </div>
    <div class="ha-des">
       <p class="black">问：我的可瀚学堂APP出现如下图的情况怎么办?</p>
       <p>答：这是由于您的iOS系统版本太低导致的，请您更新系统后再试。</p>
    </div>
    <div class="ha-img-02">
      <img src="./img/problem2.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-active {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      padding-right: p2r(30);
      img {
        width: 100%;
      }
    }
    .ha-img-02 {
      img {
        width: 90%;
      }
      padding-right: p2r(30);
      text-align: right;
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title = "其他问题? 可瀚学堂-深圳市格熙信息科技有限公司"
      this.$sendAnalytics('点击使用中的相关问题')
    },
    components: {}
  }
</script>
